import { useEffect, useRef, useState } from 'react';

export default function useConfetti() {
  const uploadContainerRef = useRef(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [confettiSize, setConfettiSize] = useState({ width: 0, height: 0 });
  const [confettiOpacity, setConfettiOpacity] = useState(0);

  useEffect(() => {
    if (uploadContainerRef.current) {
      setConfettiSize({
        width: uploadContainerRef.current.offsetWidth,
        height: uploadContainerRef.current.offsetHeight,
      });
    }
  }, []);

  const fadeOutConfetti = () => {
    let opacity = 1;
    const fadeInterval = setInterval(() => {
      opacity -= 0.05;
      setConfettiOpacity(opacity);
      if (opacity <= 0) {
        clearInterval(fadeInterval);
        setShowConfetti(false);
        setConfettiOpacity(0);
      }
    }, 50);
  };

  const triggerConfetti = () => {
    setShowConfetti(true);
    setConfettiOpacity(1);
    setTimeout(fadeOutConfetti, 2700);
  };

  const resetConfetti = () => {
    setShowConfetti(false);
    setConfettiOpacity(0);
  };

  return {
    uploadContainerRef,
    showConfetti,
    confettiSize,
    confettiOpacity,
    triggerConfetti,
    resetConfetti,
  };
}


